import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Cirkel',
    polygon: 'Polygoon',
    zip: 'Postcode',
  },
  fields: {
    name: {
      label: 'Naam',
    },
    color: {
      label: 'Kleur',
    },
    min_threshold: {
      label: 'Minimaal bestelbedrag',
    },
    max_threshold: {
      label: 'Maximaal bestelbedrag',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Bezorgkosten',
      },
      [DeliveryMode.External]: {
        label: 'Kosten betaald door restaurant',
      },
    },
    zip_codes: {
      label: 'Postcodes (elk op een nieuwe regel)',
    },
  },
  labels: {
    hidden: '(verborgen)',
  },
  buttons: {
    save: 'Opslaan',
    cancel_changes: 'Wijzigingen annuleren',
    add_max_order_amount: 'Maximaal bestelbedrag toevoegen',
  },
  modals: {
    delete_confirmation: {
      title: 'Weet u zeker dat u {{name}} wilt verwijderen',
    },
  },
  toasts: {
    failed_to_save_changes: 'Opslaan van wijzigingen voor {{name}} mislukt',
    delivery_zone_got_updated: 'Wijzigingen voor {{name}} succesvol opgeslagen',
    failed_to_delete_delivery_zone: 'Verwijderen van {{name}} mislukt',
    delivery_zone_got_deleted: '{{name}} succesvol verwijderd',
  },
};
